// layoutBlockPlaceholders.js

function normalizeBlockType(block) {
  return String(block?.type || '').trim().toUpperCase();
}

/**
 * getLayoutBlockPlaceholderLabel
 *
 * @param {object|null} block
 * @returns {string}
 */
export function getLayoutBlockPlaceholderLabel(block) {
  const blockType = normalizeBlockType(block);
  const titleOverride = String(block?.titleOverride || block?.title || '').trim();

  if (blockType === 'VIEW') {
    return titleOverride || 'PROJECT LIST';
  }

  if (blockType === 'COVER') {
    return 'COVER PHOTO';
  }

  if (blockType === 'FIELDS' || blockType === 'FIELD') {
    return titleOverride || 'FIELDS';
  }

  if (blockType === 'RICH_TEXT') {
    return 'RICH TEXT';
  }

  if (blockType === 'ROLLUP') {
    return titleOverride || 'ROLLUP';
  }

  if (blockType === 'NODE') {
    return titleOverride || 'RELATED RECORD';
  }

  if (blockType === 'VIDEO') {
    return 'VIDEO';
  }

  if (blockType === 'DISCUSSION') {
    return 'DISCUSSION';
  }

  return titleOverride || blockType || 'BLOCK';
}
